module.exports = __webpack_public_path__ + "static/media/slotMachine.24e8b4b0.png";